import React from 'react';
import { i18n } from 'config/locales';
import Field from 'components/Form/Field';

const AlcoholIntro = function () {
  return (
    <div>
      <h1 className="section-header">{i18n.t('substance.pvq.alcohol.heading.title')}</h1>
      <Field optional className="no-margin-bottom">
        {i18n.m('substance.pvq.alcohol.para.intro1')}
      </Field>
    </div>
  );
};

export default AlcoholIntro;
